import {useMemo} from "react";
import {Card} from "../../../../../components/card/card.jsx";
import SentryEchart from "../../../../../components/echarts/sentry-echart.jsx";
import useGraphViewportWidth from "../../../../../hooks/use-graph-viewport-width.js";
import {DASH_BREAKPOINTS, fluidPx} from "../../../../../utils/responsive-graph.js";
import DashCard from "../../../../../components/dash-card/dash-card.jsx";

const ALERT_STATUSES = new Set(["LANE_NOT_CONFIG", "WARNING"]);

export default function LanesCard({ lanesData }) {
    const vw = useGraphViewportWidth();

    const option = useMemo(() => {
        const statusValues = (Array.isArray(lanesData) ? lanesData : []).reduce((values, lane) => {
            if (lane?.status === "ONLINE") values.Online += 1;
            if (lane?.status === "OFFLINE") values.Offline += 1;
            if (ALERT_STATUSES.has(lane?.status)) values["Em alerta"] += 1;

            return values;
        }, {
            Online: 0,
            Offline: 0,
            "Em alerta": 0
        });
        const isCompact = vw < DASH_BREAKPOINTS.desktop;
        const legendFs = fluidPx(11, 24, vw);
        const titleFs = fluidPx(14, 28, vw);
        const pieCenter = isCompact ? ["50%", "28%"] : ["50%", "32%"];
        const pieRadius = isCompact ? ["44%", "57%"] : ["53%", "69%"];

        return {
            tooltip: {
                show: true,
                formatter: (params) => `${params.name}: ${params.value} (${params.percent.toFixed(0)}%)`
            },
            title: {
                text: "OCR",
                left: pieCenter[0],
                top: pieCenter[1],
                textAlign: "center",
                textVerticalAlign: "middle",
                padding: 0,
                textStyle: {
                    color: "#E8E8E8",
                    fontSize: titleFs,
                    fontWeight: 600
                }
            },
            legend: {
                bottom: "10%",
                left: "center",
                orient: "vertical",
                icon: "circle",
                textStyle: {
                    fontSize: legendFs,
                    rich: {
                        value: {
                            color: "#E8E8E8",
                            fontSize: legendFs,
                            fontWeight: 500
                        },
                        label: {
                            color: "#AAAAAA",
                            fontSize: legendFs,
                            fontWeight: 300
                        }
                    }
                },
                formatter: (name) => `{value|${statusValues[name] ?? 0}}  {label|${name}}`
            },
            series: [
                {
                    type: "pie",
                    radius: pieRadius,
                    center: pieCenter,
                    silent: true,
                    animation: false,
                    tooltip: {show: false},
                    label: {show: false},
                    labelLine: {show: false},
                    z: 1,
                    data: [
                        {
                            value: 1,
                            itemStyle: {
                                color: "rgba(255, 255, 255, 0.08)"
                            }
                        }
                    ]
                },
                {
                    type: "pie",
                    radius: pieRadius,
                    center: pieCenter,
                    avoidLabelOverlap: true,
                    z: 2,
                    itemStyle: {
                        borderRadius: 20
                    },
                    label: {show: false},
                    labelLine: {show: false},
                    data: [
                        {
                            value: statusValues.Online,
                            name: "Online",
                            itemStyle: {color: "#004893"}
                        },
                        {
                            value: statusValues.Offline,
                            name: "Offline",
                            itemStyle: {color: "#187dd2"}
                        },
                        {
                            value: statusValues["Em alerta"],
                            name: "Em alerta",
                            itemStyle: {color: "#2acbe2"}
                        }
                    ]
                }
            ]
        };
    }, [lanesData, vw]);

    return (
        <section className="col-span-2 flex min-h-0 flex-col">
            <Card.Header className="border-b-0! bg-transparent!">
                <Card.Title className="bg-transparent text-[#F4FFFF] text-center w-full text-(length:--font-lg)!">
                    Câmeras
                </Card.Title>
            </Card.Header>
            <Card.Body className="flex-1 min-h-0 flex pl-0! pr-(--dash-pad-md)! pb-(--dash-pad-md)!">
                <DashCard width="100%" height="100%" className="h-full w-full">
                    <SentryEchart
                        className="h-full min-h-0 w-full"
                        option={option}
                    />
                </DashCard>
            </Card.Body>
        </section>
    );
}
